/**
 * Use this to encapsulate your notification system. This file will be imported by each apps.
 */
import {snackbarUtils} from '@maltjoy/core/src/components-triggers';

export function pushNotification(message, options) {
    return snackbarUtils.pushNotification(message, options);
}

export function hideAllNotifications() {
    return snackbarUtils.deleteAllSnackbars();
}
